import translate from '@translate';
import { ProviderType } from '../../types/provider';

export type EditKeysType = keyof Omit<ProviderType, 'ID'>

export const EDIT_KEYS = [
    'COMPANY_NAME',
    'PROVIDER_EMAIL',
    'ACTIVE',
    'WEBSITE',
    'PROVIDER_STREET',
    'PROVIDER_CITY',
    'PROVIDER_STATE',
    'PROVIDER_POST_CODE',
    'DEFAULT_PRINT_FILES',
    'GLN',
    'PROVIDER_COMPANY_ID',
    'PROVIDER_TAX_ID',
    'PROVIDER_BILLING_STREET',
    'PROVIDER_BILLING_CITY',
    'PROVIDER_BILLING_STATE',
    'PROVIDER_COMPANY_PHONE',
    'SYSTEM',
    'SHOPTET_STOCK_RATIO',
    'DCIX_PROVIDER_ID',
    'STOCK_ID',
    'DEMO',
    'NAME',
    'SURNAME',
    'DEFAULT_ALLOW_EXPEDITION',
    'SEND_RECIPIENT_EMAIL_B2C_ON_THE_WAY',
    'SEND_RECIPIENT_EMAIL_B2B_ON_THE_WAY',
    'ALLOW_ORDER_PRODUCT_DETAIL',
    'PRINT_RETURN_LABEL',
    'ENABLE_RETURN_LABELS',
    'ALLOW_DISABLE_SHIPPING_REORDER',
    'CUSTOMS_WAREHOUSE_ENABLED',
    'DCIX_EXPORT_PERSONAL_DATA',
    'PROVIDER_USERS',
    'SERVICE_CODES',
    'ESHOP_KEY',
    'DCIX_PROVIDER_ID',
    'VIRTUAL_ESHOP_PARENT',
    'UPDATE_ALL_STOCK',
    'B2C_SLA',
    'B2B_SLA',
    'B2B_D0',
    'B2B_D1',
    'B2B_D2',
    'B2B_D3',
    'RECEIVING_POSTPONE_HOURS',
    'UNDER_SANCTION_ENABLED',
    'BRANCH_ID_ENABLED',
    'ALLOWED_ORDER_PRODUCTS_EDIT',
    // New fields
    'CLIENT_TYPE',
    'BUSINESS_NAME',
    'BUSINESS_FIELD',
    'SALES_REPRESENTATIVE',
    'KEY_ACCOUNT_MANAGER',
    'CONTACT_PERSON',
    'EORI',
    'BILLING_POST_CODE',
    'CONTACT_NUMBER',
    'BILLING_EMAIL',
    'CONTRACT_SIGNING_DATE',
    'CONTRACT_TERM',
    'CONTRACT_END_DATE',
    'INVOICE_DUE_DAYS',
    'NOTICE_PERIOD_MONTHS',
    'RECEIPT_DISCOUNT_12_24H',
    'RECEIPT_DISCOUNT_24_48H',
    'RECEIPT_DISCOUNT_48_72H',
    'RECEIPT_DISCOUNT_72H_PLUS',
    'RETURN_RECEIPT_DISCOUNT_12_24H',
    'RETURN_RECEIPT_DISCOUNT_24_48H',
    'RETURN_RECEIPT_DISCOUNT_48_72H',
    'RETURN_RECEIPT_DISCOUNT_72H_PLUS',
    'B2C_DISPATCH_DISCOUNT_97_95',
    'B2C_DISPATCH_DISCOUNT_94_90',
    'B2C_DISPATCH_DISCOUNT_89_LESS',
    'B2B_DISPATCH_DISCOUNT_0_100',
    'B2B_DISPATCH_DISCOUNT_101_999',
    'B2B_DISPATCH_DISCOUNT_1000_4000',
    'B2B_DISPATCH_DISCOUNT_4001_PLUS',
    'ACCEPTABLE_LOSS_PERCENT',
    'ERROR_RATE_PERCENT',
    'SLA_ALZA_SHIPPING',
    'FILES',
    // Status and lifecycle fields
    'STATUS',
    'PLANNED_LAUNCH',
    'ACTUAL_LAUNCH',
    'PLANNED_OFFBOARDING',
    'ACTUAL_OFFBOARDING',
];

export const tabs: { label: string; value: string }[] = [
    { value: 'detail', label: translate('providerDetail.detail') },
    { value: 'contract', label: translate('providerDetail.contract') },
    { value: 'sla', label: translate('providerDetail.sla') },
    { value: 'it', label: translate('providerDetail.it') },
    { value: 'transport', label: translate('providerDetail.transport') },
    { value: 'users', label: translate('providerDetail.users') },
    { value: 'history', label: translate('providerDetail.history') },
];

export const STORAGE_KEY = 'providerEditData';
